import { ExcludesFalse } from 'utils/excludesFalse';

type PostalCode = {
  fullname: string;
  code: string;
  place: string;
};

const postalCodes: Record<string, PostalCode | undefined> = {
  101: { fullname: '101 Reykjavík', code: '101', place: 'Reykjavík' },
  102: { fullname: '102 Reykjavík', code: '102', place: 'Reykjavík' },
  103: { fullname: '103 Reykjavík', code: '103', place: 'Reykjavík' },
  104: { fullname: '104 Reykjavík', code: '104', place: 'Reykjavík' },
  105: { fullname: '105 Reykjavík', code: '105', place: 'Reykjavík' },
  107: { fullname: '107 Reykjavík', code: '107', place: 'Reykjavík' },
  108: { fullname: '108 Reykjavík', code: '108', place: 'Reykjavík' },
  109: { fullname: '109 Reykjavík', code: '109', place: 'Reykjavík' },
  110: { fullname: '110 Reykjavík', code: '110', place: 'Reykjavík' },
  111: { fullname: '111 Reykjavík', code: '111', place: 'Reykjavík' },
  112: { fullname: '112 Reykjavík', code: '112', place: 'Reykjavík' },
  113: { fullname: '113 Reykjavík', code: '113', place: 'Reykjavík' },
  116: { fullname: '116 Reykjavík', code: '116', place: 'Reykjavík' },
  121: { fullname: '121 Reykjavík', code: '121', place: 'Reykjavík' },
  123: { fullname: '123 Reykjavík', code: '123', place: 'Reykjavík' },
  124: { fullname: '124 Reykjavík', code: '124', place: 'Reykjavík' },
  125: { fullname: '125 Reykjavík', code: '125', place: 'Reykjavík' },
  127: { fullname: '127 Reykjavík', code: '127', place: 'Reykjavík' },
  128: { fullname: '128 Reykjavík', code: '128', place: 'Reykjavík' },
  129: { fullname: '129 Reykjavík', code: '129', place: 'Reykjavík' },
  130: { fullname: '130 Reykjavík', code: '130', place: 'Reykjavík' },
  132: { fullname: '132 Reykjavík', code: '132', place: 'Reykjavík' },
  150: { fullname: '150 Reykjavík', code: '150', place: 'Reykjavík' },
  155: { fullname: '155 Reykjavík', code: '155', place: 'Reykjavík' },
  161: { fullname: '161 Reykjavík', code: '161', place: 'Reykjavík' },
  162: { fullname: '162 Reykjavík', code: '162', place: 'Reykjavík' },
  170: { fullname: '170 Seltjarnarnesi', code: '170', place: 'Seltjarnarnesi' },
  172: { fullname: '172 Seltjarnarnesi', code: '172', place: 'Seltjarnarnesi' },
  200: { fullname: '200 Kópavogi', code: '200', place: 'Kópavogi' },
  201: { fullname: '201 Kópavogi', code: '201', place: 'Kópavogi' },
  202: { fullname: '202 Kópavogi', code: '202', place: 'Kópavogi' },
  203: { fullname: '203 Kópavogi', code: '203', place: 'Kópavogi' },
  206: { fullname: '206 Kópavogi', code: '206', place: 'Kópavogi' },
  210: { fullname: '210 Garðabæ', code: '210', place: 'Garðabæ' },
  212: { fullname: '212 Garðabæ', code: '212', place: 'Garðabæ' },
  220: { fullname: '220 Hafnarfirði', code: '220', place: 'Hafnarfirði' },
  221: { fullname: '221 Hafnarfirði', code: '221', place: 'Hafnarfirði' },
  222: { fullname: '222 Hafnarfirði', code: '222', place: 'Hafnarfirði' },
  225: { fullname: '225 Garðabæ', code: '225', place: 'Garðabæ' },
  270: { fullname: '270 Mosfellsbæ', code: '270', place: 'Mosfellsbæ' },
  271: { fullname: '271 Mosfellsbæ', code: '271', place: 'Mosfellsbæ' },
  276: { fullname: '276 Mosfellsbæ', code: '276', place: 'Mosfellsbæ' },
  190: { fullname: '190 Vogum', code: '190', place: 'Vogum' },
  191: { fullname: '191 Vogum', code: '191', place: 'Vogum' },
  230: { fullname: '230 Reykjanesbæ', code: '230', place: 'Reykjanesbæ' },
  232: { fullname: '232 Reykjanesbæ', code: '232', place: 'Reykjanesbæ' },
  233: { fullname: '233 Reykjanesbæ', code: '233', place: 'Reykjanesbæ' },
  235: { fullname: '235 Reykjanesbæ', code: '235', place: 'Reykjanesbæ' },
  240: { fullname: '240 Grindavík', code: '240', place: 'Grindavík' },
  241: { fullname: '241 Grindavík', code: '241', place: 'Grindavík' },
  245: { fullname: '245 Suðurnesjabæ', code: '245', place: 'Suðurnesjabæ' },
  246: { fullname: '246 Suðurnesjabæ', code: '246', place: 'Suðurnesjabæ' },
  250: { fullname: '250 Suðurnesjabæ', code: '250', place: 'Suðurnesjabæ' },
  251: { fullname: '251 Suðurnesjabæ', code: '251', place: 'Suðurnesjabæ' },
  260: { fullname: '260 Reykjanesbæ', code: '260', place: 'Reykjanesbæ' },
  262: { fullname: '262 Reykjanesbæ', code: '262', place: 'Reykjanesbæ' },
  300: { fullname: '300 Akranesi', code: '300', place: 'Akranesi' },
  301: { fullname: '301 Akranesi', code: '301', place: 'Akranesi' },
  302: { fullname: '302 Akranesi', code: '302', place: 'Akranesi' },
  310: { fullname: '310 Borgarnesi', code: '310', place: 'Borgarnesi' },
  311: { fullname: '311 Borgarnesi', code: '311', place: 'Borgarnesi' },
  320: {
    fullname: '320 Reykholti í Borgarfirði',
    code: '320',
    place: 'Reykholti í Borgarfirði',
  },
  340: { fullname: '340 Stykkishólmi', code: '340', place: 'Stykkishólmi' },
  341: { fullname: '341 Stykkishólmi', code: '341', place: 'Stykkishólmi' },
  342: { fullname: '342 Stykkishólmi', code: '342', place: 'Stykkishólmi' },
  345: {
    fullname: '345 Flatey á Breiðafirði',
    code: '345',
    place: 'Flatey á Breiðafirði',
  },
  350: { fullname: '350 Grundarfirði', code: '350', place: 'Grundarfirði' },
  351: { fullname: '351 Grundarfirði', code: '351', place: 'Grundarfirði' },
  355: { fullname: '355 Ólafsvík', code: '355', place: 'Ólafsvík' },
  356: { fullname: '356 Snæfellsbæ', code: '356', place: 'Snæfellsbæ' },
  360: { fullname: '360 Hellissandi', code: '360', place: 'Hellissandi' },
  370: { fullname: '370 Búðardal', code: '370', place: 'Búðardal' },
  371: { fullname: '371 Búðardal', code: '371', place: 'Búðardal' },
  380: { fullname: '380 Reykhólahreppi', code: '380', place: 'Reykhólahreppi' },
  381: { fullname: '381 Reykhólahreppi', code: '381', place: 'Reykhólahreppi' },
  400: { fullname: '400 Ísafirði', code: '400', place: 'Ísafirði' },
  401: { fullname: '401 Ísafirði', code: '401', place: 'Ísafirði' },
  410: { fullname: '410 Hnífsdal', code: '410', place: 'Hnífsdal' },
  415: { fullname: '415 Bolungarvík', code: '415', place: 'Bolungarvík' },
  416: { fullname: '416 Bolungarvík', code: '416', place: 'Bolungarvík' },
  420: { fullname: '420 Súðavík', code: '420', place: 'Súðavík' },
  421: { fullname: '421 Súðavík', code: '421', place: 'Súðavík' },
  425: { fullname: '425 Flateyri', code: '425', place: 'Flateyri' },
  426: { fullname: '426 Flateyri', code: '426', place: 'Flateyri' },
  430: { fullname: '430 Suðureyri', code: '430', place: 'Suðureyri' },
  431: { fullname: '431 Suðureyri', code: '431', place: 'Suðureyri' },
  450: { fullname: '450 Patreksfirði', code: '450', place: 'Patreksfirði' },
  451: { fullname: '451 Patreksfirði', code: '451', place: 'Patreksfirði' },
  460: { fullname: '460 Tálknafirði', code: '460', place: 'Tálknafirði' },
  461: { fullname: '461 Tálknafirði', code: '461', place: 'Tálknafirði' },
  465: { fullname: '465 Bíldudal', code: '465', place: 'Bíldudal' },
  466: { fullname: '466 Bíldudal', code: '466', place: 'Bíldudal' },
  470: { fullname: '470 Þingeyri', code: '470', place: 'Þingeyri' },
  471: { fullname: '471 Þingeyri', code: '471', place: 'Þingeyri' },
  500: { fullname: '500 Stað', code: '500', place: 'Stað' },
  510: { fullname: '510 Hólmavík', code: '510', place: 'Hólmavík' },
  511: { fullname: '511 Hólmavík', code: '511', place: 'Hólmavík' },
  512: { fullname: '512 Hólmavík', code: '512', place: 'Hólmavík' },
  520: { fullname: '520 Drangsnesi', code: '520', place: 'Drangsnesi' },
  524: { fullname: '524 Árneshreppi', code: '524', place: 'Árneshreppi' },
  530: { fullname: '530 Hvammstanga', code: '530', place: 'Hvammstanga' },
  531: { fullname: '531 Hvammstanga', code: '531', place: 'Hvammstanga' },
  540: { fullname: '540 Blönduósi', code: '540', place: 'Blönduósi' },
  541: { fullname: '541 Blönduósi', code: '541', place: 'Blönduósi' },
  545: { fullname: '545 Skagaströnd', code: '545', place: 'Skagaströnd' },
  546: { fullname: '546 Skagaströnd', code: '546', place: 'Skagaströnd' },
  550: { fullname: '550 Sauðárkróki', code: '550', place: 'Sauðárkróki' },
  551: { fullname: '551 Sauðárkróki', code: '551', place: 'Sauðárkróki' },
  560: { fullname: '560 Varmahlíð', code: '560', place: 'Varmahlíð' },
  561: { fullname: '561 Varmahlíð', code: '561', place: 'Varmahlíð' },
  565: { fullname: '565 Hofsósi', code: '565', place: 'Hofsósi' },
  566: { fullname: '566 Hofsósi', code: '566', place: 'Hofsósi' },
  570: { fullname: '570 Fljótum', code: '570', place: 'Fljótum' },
  580: { fullname: '580 Siglufirði', code: '580', place: 'Siglufirði' },
  581: { fullname: '581 Siglufirði', code: '581', place: 'Siglufirði' },
  600: { fullname: '600 Akureyri', code: '600', place: 'Akureyri' },
  601: { fullname: '601 Akureyri', code: '601', place: 'Akureyri' },
  602: { fullname: '602 Akureyri', code: '602', place: 'Akureyri' },
  603: { fullname: '603 Akureyri', code: '603', place: 'Akureyri' },
  604: { fullname: '604 Akureyri', code: '604', place: 'Akureyri' },
  605: { fullname: '605 Akureyri', code: '605', place: 'Akureyri' },
  606: { fullname: '606 Akureyri', code: '606', place: 'Akureyri' },
  607: { fullname: '607 Akureyri', code: '607', place: 'Akureyri' },
  610: { fullname: '610 Grenivík', code: '610', place: 'Grenivík' },
  611: { fullname: '611 Grímsey', code: '611', place: 'Grímsey' },
  616: { fullname: '616 Grenivík', code: '616', place: 'Grenivík' },
  620: { fullname: '620 Dalvík', code: '620', place: 'Dalvík' },
  621: { fullname: '621 Dalvík', code: '621', place: 'Dalvík' },
  625: { fullname: '625 Ólafsfirði', code: '625', place: 'Ólafsfirði' },
  626: { fullname: '626 Ólafsfirði', code: '626', place: 'Ólafsfirði' },
  630: { fullname: '630 Hrísey', code: '630', place: 'Hrísey' },
  640: { fullname: '640 Húsavík', code: '640', place: 'Húsavík' },
  641: { fullname: '641 Húsavík', code: '641', place: 'Húsavík' },
  645: { fullname: '645 Fosshóli', code: '645', place: 'Fosshóli' },
  650: { fullname: '650 Laugum', code: '650', place: 'Laugum' },
  660: { fullname: '660 Mývatni', code: '660', place: 'Mývatni' },
  670: { fullname: '670 Kópaskeri', code: '670', place: 'Kópaskeri' },
  671: { fullname: '671 Kópaskeri', code: '671', place: 'Kópaskeri' },
  675: { fullname: '675 Raufarhöfn', code: '675', place: 'Raufarhöfn' },
  676: { fullname: '676 Raufarhöfn', code: '676', place: 'Raufarhöfn' },
  680: { fullname: '680 Þórshöfn', code: '680', place: 'Þórshöfn' },
  681: { fullname: '681 Þórshöfn', code: '681', place: 'Þórshöfn' },
  685: { fullname: '685 Bakkafirði', code: '685', place: 'Bakkafirði' },
  686: { fullname: '686 Bakkafirði', code: '686', place: 'Bakkafirði' },
  690: { fullname: '690 Vopnafirði', code: '690', place: 'Vopnafirði' },
  691: { fullname: '691 Vopnafirði', code: '691', place: 'Vopnafirði' },
  700: { fullname: '700 Egilsstöðum', code: '700', place: 'Egilsstöðum' },
  701: { fullname: '701 Egilsstöðum', code: '701', place: 'Egilsstöðum' },
  710: { fullname: '710 Seyðisfirði', code: '710', place: 'Seyðisfirði' },
  711: { fullname: '711 Seyðisfirði', code: '711', place: 'Seyðisfirði' },
  715: { fullname: '715 Mjóafirði', code: '715', place: 'Mjóafirði' },
  720: {
    fullname: '720 Borgarfirði (eystri)',
    code: '720',
    place: 'Borgarfirði (eystri)',
  },
  721: {
    fullname: '721 Borgarfirði (eystri)',
    code: '721',
    place: 'Borgarfirði (eystri)',
  },
  730: { fullname: '730 Reyðarfirði', code: '730', place: 'Reyðarfirði' },
  731: { fullname: '731 Reyðarfirði', code: '731', place: 'Reyðarfirði' },
  735: { fullname: '735 Eskifirði', code: '735', place: 'Eskifirði' },
  736: { fullname: '736 Eskifirði', code: '736', place: 'Eskifirði' },
  740: { fullname: '740 Neskaupstað', code: '740', place: 'Neskaupstað' },
  741: { fullname: '741 Neskaupstað', code: '741', place: 'Neskaupstað' },
  750: { fullname: '750 Fáskrúðsfirði', code: '750', place: 'Fáskrúðsfirði' },
  751: { fullname: '751 Fáskrúðsfirði', code: '751', place: 'Fáskrúðsfirði' },
  755: { fullname: '755 Stöðvarfirði', code: '755', place: 'Stöðvarfirði' },
  756: { fullname: '756 Stöðvarfirði', code: '756', place: 'Stöðvarfirði' },
  760: { fullname: '760 Breiðdalsvík', code: '760', place: 'Breiðdalsvík' },
  761: { fullname: '761 Breiðdalsvík', code: '761', place: 'Breiðdalsvík' },
  765: { fullname: '765 Djúpavogi', code: '765', place: 'Djúpavogi' },
  766: { fullname: '766 Djúpavogi', code: '766', place: 'Djúpavogi' },
  780: {
    fullname: '780 Höfn í Hornafirði',
    code: '780',
    place: 'Höfn í Hornafirði',
  },
  781: {
    fullname: '781 Höfn í Hornafirði',
    code: '781',
    place: 'Höfn í Hornafirði',
  },
  785: { fullname: '785 Öræfum', code: '785', place: 'Öræfum' },
  800: { fullname: '800 Selfossi', code: '800', place: 'Selfossi' },
  801: { fullname: '801 Selfossi', code: '801', place: 'Selfossi' },
  802: { fullname: '802 Selfossi', code: '802', place: 'Selfossi' },
  803: { fullname: '803 Selfossi', code: '803', place: 'Selfossi' },
  804: { fullname: '804 Selfossi', code: '804', place: 'Selfossi' },
  805: { fullname: '805 Selfossi', code: '805', place: 'Selfossi' },
  806: { fullname: '806 Selfossi', code: '806', place: 'Selfossi' },
  810: { fullname: '810 Hveragerði', code: '810', place: 'Hveragerði' },
  815: { fullname: '815 Þorlákshöfn', code: '815', place: 'Þorlákshöfn' },
  816: { fullname: '816 Ölfusi', code: '816', place: 'Ölfusi' },
  820: { fullname: '820 Eyrarbakka', code: '820', place: 'Eyrarbakka' },
  825: { fullname: '825 Stokkseyri', code: '825', place: 'Stokkseyri' },
  840: { fullname: '840 Laugarvatni', code: '840', place: 'Laugarvatni' },
  845: { fullname: '845 Flúðum', code: '845', place: 'Flúðum' },
  846: { fullname: '846 Flúðum', code: '846', place: 'Flúðum' },
  850: { fullname: '850 Hellu', code: '850', place: 'Hellu' },
  851: { fullname: '851 Hellu', code: '851', place: 'Hellu' },
  860: { fullname: '860 Hvolsvelli', code: '860', place: 'Hvolsvelli' },
  861: { fullname: '861 Hvolsvelli', code: '861', place: 'Hvolsvelli' },
  870: { fullname: '870 Vík', code: '870', place: 'Vík' },
  871: { fullname: '871 Vík', code: '871', place: 'Vík' },
  880: {
    fullname: '880 Kirkjubæjarklaustri',
    code: '880',
    place: 'Kirkjubæjarklaustri',
  },
  881: {
    fullname: '881 Kirkjubæjarklaustri',
    code: '881',
    place: 'Kirkjubæjarklaustri',
  },
  900: { fullname: '900 Vestmannaeyjum', code: '900', place: 'Vestmannaeyjum' },
  902: { fullname: '902 Vestmannaeyjum', code: '902', place: 'Vestmannaeyjum' },
};

/**
 * Matches the string representation of postal code + city since there might be
 * different grammatical cases (e.g. nefnifall VS þágufall).
 *
 * @param address User addresses, both new and old
 * @param postalCodes List of postal codes, most likely the above list
 * @returns Postal code and city that matches an item in `postalCodes`
 */
export function mapOldPostalCodeToPostalCodes(
  postalCode: string,
  defaultValue?: string
): string {
  const found = postalCodes[postalCode];

  if (found) {
    return found.fullname;
  }

  return defaultValue ?? postalCode;
}

export function postalCodesToOptions() {
  return (
    Object.entries(postalCodes)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .map(([key, value]) => {
        if (!value) {
          return false;
        }

        return {
          title: value.fullname,
          value: value.fullname,
        };
      })
      .filter(Boolean as unknown as ExcludesFalse)
  );
}
